import { effect, signal } from '@preact/signals';
import { migrateSettings, type Settings } from './settingsSchema';
import { readJson, writeJson } from './storage';

export type { ProxyMode, Settings } from './settingsSchema';

const KEY = 'ct:settings:v2';

export const settings = signal<Settings>(migrateSettings(readJson<unknown>(KEY, {})));

export function updateSettings(patch: Partial<Settings>): void {
  settings.value = { ...settings.value, ...patch };
}

effect(() => {
  writeJson(KEY, settings.value);
  if (typeof document !== 'undefined') {
    const t = settings.value.theme;
    if (t === 'auto') delete document.documentElement.dataset.theme;
    else document.documentElement.dataset.theme = t;
  }
});
